// extracted by mini-css-extract-plugin
export var divider = "_fo-7";
export var itemsToggle = "_fo-8";
export var mergeModal = "_fo-1";
export var optionCard = "_fo-4";
export var radioGroup = "_fo-6";
export var radioOption = "_fo-0";
export var selected = "_fo-5";
export var shipmentOptions = "_fo-2";
export var tableOptions = "_fo-3";